"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.PointerDispatchContext = exports.PointerContext = void 0;
exports.reducer = reducer;
exports.useStore = exports.useDispatch = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _react = require("react");
var initialState = exports.initialState = {};
var PointerContext = exports.PointerContext = /*#__PURE__*/(0, _react.createContext)(initialState);
var PointerDispatchContext = exports.PointerDispatchContext = /*#__PURE__*/(0, _react.createContext)(function () {});
function reducer(tasks, action) {
  if (action && Object.keys(action).length === 0) return initialState;
  return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, tasks), action);
}
var useStore = exports.useStore = function useStore() {
  return (0, _react.useContext)(PointerContext);
};
var useDispatch = exports.useDispatch = function useDispatch() {
  return (0, _react.useContext)(PointerDispatchContext);
};